import React from "react";
import { colorCorrectionData } from "./ColorCorrectionData";
import { Link } from "react-router-dom";
import CompareSlider from "../../home/CompareSlider";
import { Flex } from "antd";
import cullingImage from "../../../images/services/Culling.jpeg";
import wpsBefore from "../../../images/services/WPS_before.webp";
import wpsAfter from "../../../images/services/WPS_after.webp";

const LandingPage = () => {
  const imagePairs = [
    {
      firstImage: "/images/color_correction_before2.jpg",
      secondImage: "/images/color_correction_after2.jpg",
    },
    {
      firstImage: wpsBefore,
      secondImage: wpsAfter,
    },
    {
      firstImage: "/images/Wedding 1 Be.jpg",
      secondImage: "/images/Wedding 1.jpg",
    },
  ];
  const maxItems = Math.min(colorCorrectionData.length, imagePairs.length);

  return (
    <>
      <div
        className="bg_maincolor d-flex align-items-center justify-content-center"
        style={{ height: "14rem" }}
      >
        <h1 className="display-6 fw-bold prata-regular text-center text-light ">
          Color Correction Services
        </h1>
      </div>
      <div className="mx-5">
        {Array.from({ length: maxItems }).map((_, index) => (
          <div
            key={index}
            className={`row my-5 py-5 align-items-center ${
              index % 2 !== 0 ? "flex-row-reverse " : ""
            }`}
          >
            <div className="col-md-6">
              <CompareSlider
                firstImage={imagePairs[index].firstImage}
                secondImage={imagePairs[index].secondImage}
                initialSliderPercentage={50}
              />
            </div>
            <div className="col-md-6 px-5">
              <h2 className="prata-regular fs-2 ">
                {colorCorrectionData[index].title}
              </h2>
              <p>
                {colorCorrectionData[index].para1 &&
                  colorCorrectionData[index].para1}
              </p>{" "}
              {/* <p>
                <b> {colorCorrectionData[index].heading}</b>
              </p>{" "} */}
              {/* <p>
                <b> {colorCorrectionData[index].heading1}</b>
              </p> */}
              <p>
                {colorCorrectionData[index].para2 &&
                  colorCorrectionData[index].para2}
              </p>{" "}
              {/* <p>
                <b> {colorCorrectionData[index].heading2}</b>
              </p> */}
              <p>
                {colorCorrectionData[index].para3 &&
                  colorCorrectionData[index].para3}
              </p>
              {/* <p>
                <b> {colorCorrectionData[index].heading3}</b>
              </p> */}
              {/* <p>
                {colorCorrectionData[index].para4 &&
                  colorCorrectionData[index].para4}
              </p>
              <p>
                <b> {colorCorrectionData[index].heading4}</b>
              </p>
              <p>
                {colorCorrectionData[index].para5 &&
                  colorCorrectionData[index].para5}
              </p>
              <p>
                <b> {colorCorrectionData[index].heading5}</b>
              </p> */}
              <ul>
                {colorCorrectionData[index].list1 && (
                  <li>{colorCorrectionData[index].list1}</li>
                )}
                {colorCorrectionData[index].list2 && (
                  <li>{colorCorrectionData[index].list2}</li>
                )}
                {colorCorrectionData[index].list3 && (
                  <li>{colorCorrectionData[index].list3}</li>
                )}
                {colorCorrectionData[index].list4 && (
                  <li>{colorCorrectionData[index].list4}</li>
                )}
                {colorCorrectionData[index].list5 && (
                  <li>{colorCorrectionData[index].list5}</li>
                )}{" "}
                {colorCorrectionData[index].list6 && (
                  <li>{colorCorrectionData[index].list6}</li>
                )}{" "}
                {colorCorrectionData[index].list7 && (
                  <li>{colorCorrectionData[index].list7}</li>
                )}{" "}
                {colorCorrectionData[index].list8 && (
                  <li>{colorCorrectionData[index].list8}</li>
                )}{" "}
                {colorCorrectionData[index].list9 && (
                  <li>{colorCorrectionData[index].list9}</li>
                )}{" "}
                {colorCorrectionData[index].list10 && (
                  <li>{colorCorrectionData[index].list10}</li>
                )}{" "}
                {colorCorrectionData[index].list11 && (
                  <li>{colorCorrectionData[index].list11}</li>
                )}{" "}
                {colorCorrectionData[index].list12 && (
                  <li>{colorCorrectionData[index].list12}</li>
                )}{" "}
                {colorCorrectionData[index].list13 && (
                  <li>{colorCorrectionData[index].list13}</li>
                )}{" "}
                {colorCorrectionData[index].list14 && (
                  <li>{colorCorrectionData[index].list14}</li>
                )}
              </ul>
            </div>
          </div>
        ))}

        <div className="row align-items-center justify-content-center my-5 py-5">
          <div className="col-md-6">
            <div className="compare-slider" style={{ cursor: "default" }}>
              <img
                src={cullingImage}
                alt="Culling"
                className="compare-image"
                style={{ position: "static" }}
              />
            </div>
          </div>
          <div className="col-md-6">
            <h2 className="prata-regular fs-2 ">
              Let Us Handle the Culling, So You Can Focus on the Magic{" "}
            </h2>
            <p>
              <b> Only $0.02 per photo.</b>
            </p>
            <p>
              As a wedding photographer, you know the story is in the details
              —but sorting through thousands of images to find the perfect ones
              takes time. At Captureedits, we provide expert wedding photo
              culling services to help you save hours and stay focused on what
              you love: creating timeless memories for your clients.
            </p>
            <p>
              <b>What’s Included</b>
            </p>
            <p>
              <b>Precise Selection of the Best Moments</b>{" "}
            </p>
            <p>
              We carefully go through your entire shoot to select only the
              sharpes t, most emotional, and visually appealing photos.
            </p>
            <p>
              <b>Remove Blinks, Duplicates & Missed Shots </b>
            </p>
            <p>
              Our trained eyes eliminate unnecessary or fl awed images, giving
              you a clean, refined gallery to edit.
            </p>
            <p>
              <b>Fast & Reliable Turnaround </b>
            </p>
            <p>
              We know deadlines matter— especially for weddings. Get your culled
              images back fast without compromising quality.
            </p>
            <p>
              <b>Custom Preferences? No Problem.</b>
            </p>
            <p>
              Prefer more candid sho ts or certain poses? We follow your exact
              style and preferences to maintain your artistic vision
            </p>
            <p>
              <b>Why Wedding Photographers Trust Us</b>
            </p>
            <ul>
              <li>Save up to 6 -1 0 hours per wedding</li>
              <li>Maintain a consistent storytelling style </li>
              <li>
                Focus on editing the best images —not di gging through them{" "}
              </li>
              <li>Secure file handling and 100% confidentiality</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        <Link
          to="/colorcorrection-order"
          className="btn bg_maincolor mb-5 text-white"
        >
          Order Now
        </Link>
      </div>
    </>
  );
};

export default LandingPage;
